import React, { useEffect } from "react";
import { LAYOUT_STRUCTURE_OPTIONS } from "../../../../optics/components/drawers/settings/features/announcements/defaults";
import { contentPropertyService } from "@Shared/Service/ContentPropertyService";
import { getContentProperty, getUserById } from "../../announcements-api";

export const useParticipants = (
  { viewMode, data, config },
  { setParticipants, setCurrentUser, setHasCurrentUserAccepted }
) => {
  useEffect(() => {
    if (
      viewMode === "view" &&
      config.layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.PARTICIPANTS)
    ) {
      (async () => {
        const { body } = await window.AP.request("/rest/api/user/current");
        const user = JSON.parse(body);

        setCurrentUser({
          key: user.accountId,
          name: user.displayName,
          src: `${window.AP._hostOrigin}${user.profilePicture.path}`,
        });

        const contentProperty = await getContentProperty(data.id);
        if (
          contentProperty.data.propertyExists &&
          !!contentProperty.data.body.results.length
        ) {
          const {
            value: { participants },
          } = contentProperty.data.body.results[0];

          setHasCurrentUserAccepted(
            !!participants.find(
              (participantId) => participantId === user.accountId
            )
          );

          const fetchedUsers = await Promise.all(
            participants
              .map((participantId) => getUserById(participantId))
              .filter((participant) => participant)
          );

          setParticipants([...fetchedUsers]);
        } else {
          await contentPropertyService.createContentProperty(
            `caelor-${data.id}`,
            {
              participants: [],
            }
          );
        }
      })();
    }
  }, [
    viewMode,
    data.id,
    config.layoutStructure,
    setCurrentUser,
    setHasCurrentUserAccepted,
    setParticipants,
  ]);
};
